import { ICertification } from '../interfaces/certifications';
import { OperationType } from '../surveyjs/common/types/enums';

export const shouldHideRefreshButton = (
  certification: ICertification,
  allCertifications: ICertification[]
): boolean => {
  // Don't hide if this certification is from the current (non-deleted) subscription
  if (!certification.isSubscriptionDeleted) {
    return false;
  }

  // Find the current active subscription for this specific accreditation type
  const currentSubscription = allCertifications.find(
    c => c.accreditationTypeId === certification.accreditationTypeId && !c.isSubscriptionDeleted
  );

  // If no current subscription exists, don't hide
  if (!currentSubscription) {
    return false;
  }

  // Hide refresh button if:
  // 1. Current subscription is a scope change
  // 2. This certification is from a different (deleted) subscription
  return (
    currentSubscription.operationType === OperationType.ScopeChange &&
    certification.subscriptionId !== currentSubscription.subscriptionId
  );
};
